
let availableCountries = [];
let detectedCountryISO = ''; // 전역 변수로 선언


document.addEventListener('DOMContentLoaded', () => {

    const popupCrcValue = getCookie("popupCrc");

    if (popupCrcValue) {
          handleLocalizationSubmission("popupCrc");
    }
  

  //popup var
  const crcPopupBg = document.querySelector('.crc-popup-bg');
  const crcPopupSaveButton = document.querySelector('.save-btn');
  const localizationFormPopup = document.getElementById('localization_form');
  const crcPopupCancelButton = document.querySelector('.cancel-btn');
  const crcPopupClsButton = document.getElementById('crc-popup-close');

  
  const countryCode = document.getElementById('country_code').value;
  const languageCode = document.getElementById('language_code').value;
  
  // Hide UI on save button click and submit form
  // Hide UI on save button click and submit form
  crcPopupSaveButton.addEventListener('click', (event) => {
    event.preventDefault();
    crcPopupBg.classList.remove('init');
    let selectedPopupCountryValue = document.getElementById('popup-country-select').value;
    let selectedPopupLanguageValue = document.getElementById('popup-lang-select').value;
    const cookieValue = JSON.stringify({ hidden: true, country_code: selectedPopupCountryValue, language_code: selectedPopupLanguageValue });    
    setCookie("popupCrc", cookieValue, 30);
    localizationFormPopup.submit();
  });


  
  crcPopupCancelButton.addEventListener('click', () => {
    const cookieValue = JSON.stringify({ hidden: true, country_code: countryCode, language_code: languageCode });
    setCookie("popupCrc", cookieValue, 30);  
    crcPopupBg.classList.remove('init');
  });
  
  crcPopupClsButton.addEventListener('click', () => {
    const cookieValue = JSON.stringify({ hidden: true, country_code: countryCode, language_code: languageCode });
    setCookie("popupCrc", cookieValue, 30);  
    crcPopupBg.classList.remove('init');
  });
  

  
  // Hide popup if cookie is set

    
  popupInitSetup();
  crcCallback();


  const currencyBtn = document.querySelector('.currency-btn');
  const currencyWrap = document.querySelector('.currency-wrap');
  const currencyBox = document.querySelector('.currency-box');
  const currencyBoxCls = document.getElementById('currency-box-close');

  // .currency-btn 클릭 시 .currency-wrap에 active 클래스 추가
  if (currencyBtn) {
    currencyBtn.addEventListener('click', () => {
      currencyWrap.classList.add('active');
    });
  } 


  // .currency-wrap 클릭 시 active 클래스 제거
  if (currencyWrap) {
    currencyWrap.addEventListener('click', () => {
      currencyWrap.classList.remove('active');
    });
  }
  
  // #currency-box-close 클릭 시 active 클래스 제거
  if (currencyBoxCls) {
    currencyBoxCls.addEventListener('click', () => {
      currencyWrap.classList.remove('active');
    });
  }  
  

  // .currency-box 클릭 시 이벤트 전파 방지
  if (currencyBox) {
    currencyBox.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  //side bar 검색UI
  const searchInput = document.getElementById('regionSearch');
  const searchHistoryDiv = document.querySelector('.search-history');
  const countryCodeInput = document.getElementById('country_code');
  const languageCodeInput = document.getElementById('language_code');
  const languageSelect = document.getElementById('lang-select'); // ID로 특정 언어 선택 <select> 요소를 선택

  languageSelect.addEventListener('change', () => {
    const selectedLanguage = languageSelect.value;
    const fixCountryValue = document.getElementById('country_code').value;

    const cookieValue = JSON.stringify({ hidden: true, country_code: fixCountryValue, language_code: selectedLanguage });
    setCookie("popupCrc", cookieValue, 30);  
    

    localizationFormPopup.submit();
  });
    
    
  searchInput.addEventListener('input', function() {
    const query = searchInput.value.toLowerCase().trim();
  
    // 검색 결과를 비웁니다.
    searchHistoryDiv.innerHTML = '';
  
    // 입력 필드가 비어 있는 경우 전체 국가 목록을 렌더링하고 함수 종료
    if (query === '') {
      renderAllCountriesUI(availableCountries);
      return;
    }
  
    // 국가 이름이나 언어 이름과 일치하는 결과 필터링
    const filteredResults = availableCountries.reduce((acc, country) => {
      // 국가 이름과 일치하는지 확인
      const countryMatch = country.name.toLowerCase().includes(query);
  
      // 해당 국가의 언어들 중 검색어와 일치하는 언어 필터링
      const languageMatches = country.availableLanguages.filter(language =>
        language.name.toLowerCase().includes(query)
      );
  
      // 국가 이름이나 언어 이름이 일치할 경우 결과에 추가
      if (countryMatch || languageMatches.length > 0) {
        acc.push({
          ...country,
          availableLanguages: countryMatch ? country.availableLanguages : languageMatches,

        });
      }
  
      return acc;
    }, []);
  
    // 필터링된 결과를 UI에 렌더링
    filteredResults.forEach(country => {
      country.availableLanguages.forEach(language => {
        const resultDiv = document.createElement('div');
        const countryParagraph = document.createElement('p');
        const languageParagraph = document.createElement('p');
  
        resultDiv.classList.add('linkbtn', 'result-link');
        resultDiv.setAttribute('data-country', country.isoCode);        
        //resultDiv.setAttribute('data-language', language.isoCode );        
        resultDiv.setAttribute('data-language', convertIsoCode(language.isoCode) );
        resultDiv.setAttribute('data-market', country.market?.handle || ''); // 데이터 속성에 마켓 핸들 추가

        // 국가 이름과 통화 정보를 표시합니다.
        countryParagraph.textContent = `${country.name} (${country.currency.isoCode} ${country.currency.symbol})`;
        languageParagraph.textContent = language.name;
        languageParagraph.classList.add('lang');
  
        resultDiv.appendChild(countryParagraph);
        resultDiv.appendChild(languageParagraph);
        searchHistoryDiv.appendChild(resultDiv);
      });
    });
  });
  
    
  
  //const convertedCode = convertIsoCode(language.isoCode);       

  
  // 검색 결과에서 동적으로 생성된 div 클릭 이벤트
  searchHistoryDiv.addEventListener('click', (event) => {
    const clickedDiv = event.target.closest('.result-link'); // 클릭한 요소의 부모가 result-link 인지 확인

    if (clickedDiv) {
      const selectedCountry = clickedDiv.getAttribute('data-country');
      const selectedLanguage = clickedDiv.getAttribute('data-language');

      // 히든 필드에 값 설정
      countryCodeInput.value = selectedCountry;
      languageCodeInput.value = selectedLanguage;

      // SAVE 버튼 클릭 로직과 동일하게 처리
      const cookieValue = JSON.stringify({ hidden: true, country_code: selectedCountry, language_code: selectedLanguage });
      setCookie("popupCrc", cookieValue, 30);

      // 폼을 제출합니다.
      localizationFormPopup.submit();
    }
  });


  
  
});


function convertIsoCode(isoCode) {
  // 언더스코어를 하이픈으로 변환
  return isoCode.replace("_", "-");
}    


// Initialize default country and language options
const defaultCountries = [{ isoCode: 'Loading', name: 'Loading', availableLanguages: [{ isoCode: 'Loading', name: 'Loading' }] }];

function popupInitSetup() {
  const countrySelect = document.getElementById('popup-country-select');
  const langSelect = document.getElementById('popup-lang-select');

  defaultCountries.forEach((country) => {
    const option = new Option(country.name, country.isoCode);
    countrySelect.add(option);

    country.availableLanguages.forEach((language) => {
      const langOption = new Option(language.name, language.isoCode);
      langSelect.add(langOption);
    });
  });
}
const storeName = 'lewkin.myshopify.com';
const accessToken = '98ebdc52aa75b39c9908292616223057';

// Fetch country and language options from Shopify API
async function crcCallback() {
  const crcPopupBg = document.querySelector('.crc-popup-bg');

  
  const query = `
    {
      localization {
        availableCountries {
          isoCode
          name
          market {
            handle
            id
          }          
          currency {
            isoCode
            symbol
          }
          availableLanguages {
            isoCode
            name
          }
        }
      }
    }
  `;

  try {
    const response = await fetch(`https://${storeName}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken
      },
      body: JSON.stringify({ query })
    });

    if (!response.ok) throw new Error('Network response was not ok');

    const result = await response.json();
    if (result.errors) {
      console.error("GraphQL Errors:", result.errors);
      return;
    }

    const initialCountryCode = document.getElementById('country_code').value; // 초기 국가 코드 값
    const initialLanguageCode = document.getElementById('language_code').value; // 초기 언어 코드 값
    const popupCrcValue = getCookie("popupCrc");

    availableCountries = result.data.localization.availableCountries;

    if (!popupCrcValue.includes("hidden")) {
      // IP 기반 지역 정보 가져오기
      await getRegionInfo();      
    }

    
    // 전체 국가 UI 렌더링 함수 호출
    renderAllCountriesUI(availableCountries);
    shx(availableCountries);


    
    initializeCountryAndLanguageOptions(
      result.data.localization.availableCountries,
      detectedCountryISO,
      initialCountryCode, 
      initialLanguageCode
    );
  
    
    if (!popupCrcValue.includes("hidden")) {      
      crcPopupBg.classList.add('init');
    }

    //getRegionInfo();

  
  } catch (error) {
    console.error("Fetch Error:", error);
  }
}

function initializeCountryAndLanguageOptions(countries, initialCountryCode, initialLanguageCode) {
  const countrySelect = document.getElementById('popup-country-select');
  const popupCrcValue = getCookie("popupCrc");

  
  countrySelect.innerHTML = ''; // 기존 옵션 제거
  countries.sort((a, b) => a.name.localeCompare(b.name, 'ko'));

  countries.forEach(country => {
    const option = new Option(country.name, country.isoCode);
    
    // 초기값과 일치하는 ISO 코드를 가진 국가 선택

    if (country.isoCode === detectedCountryISO || country.isoCode === initialCountryCode) {
        option.selected = true;
    }
    
    countrySelect.add(option);
  });

  const selectedCountry = countries.find(country => country.isoCode === initialCountryCode) || countries[0];

    
  if (!popupCrcValue.includes("hidden")) {      

    if (selectedCountry) {
      updateLanguageOptions(selectedCountry.availableLanguages, initialLanguageCode);
      updateHiddenFields(selectedCountry.isoCode, initialLanguageCode);
    }
    
  }
  


  // 국가 변경 시 언어 목록 업데이트
  countrySelect.addEventListener('change', () => handleCountryChange(countries));
}

function handleCountryChange(countries) {
  const selectedCountryCode = document.getElementById('popup-country-select').value;
  const selectedCountry = countries.find(country => country.isoCode === selectedCountryCode);

  if (selectedCountry) {
    const firstLanguageCode = selectedCountry.availableLanguages[0]?.isoCode || null;
    updateLanguageOptions(selectedCountry.availableLanguages, firstLanguageCode);
    updateHiddenFields(selectedCountryCode, firstLanguageCode);
  } else {
    console.log('Selected country not found');
  }
}

function updateLanguageOptions(languages, selectedLanguageCode = null) {
  const langSelect = document.getElementById('popup-lang-select');
  langSelect.innerHTML = ''; // 기존 옵션 제거

  languages.forEach(language => {
    const langOption = new Option(language.name, language.isoCode);

    // 초기 로드 시 selectedLanguageCode가 설정되어 있으면 해당 언어 선택
    if (selectedLanguageCode && language.isoCode.toLowerCase() === selectedLanguageCode.toLowerCase()) {
      langOption.selected = true;
    }

    langSelect.add(langOption);
  });
  
  // 언어 선택 기본값 업데이트
  if (!selectedLanguageCode && languages.length > 0) {
      const currentCountryCode = document.getElementById('country_code').value;
      const currentLanguageCode = document.getElementById('language_code').value;
  
      // 이미 Liquid 값이 설정되어 있으면 업데이트를 생략
      if (currentLanguageCode) {
          console.log("Liquid 값이 이미 설정되어 있으므로 업데이트를 건너뜁니다.");
          return;
      }
  
      updateHiddenFields(currentCountryCode, langSelect.value);
  } else if (selectedLanguageCode) {
      const currentCountryCode = document.getElementById('country_code').value;
      const currentLanguageCode = document.getElementById('language_code').value;
  
      // 이미 Liquid 값이 설정되어 있으면 업데이트를 생략
      if (currentLanguageCode === selectedLanguageCode) {
          console.log("Liquid 값과 동일하므로 업데이트를 건너뜁니다.");
          return;
      }
  
      updateHiddenFields(currentCountryCode, selectedLanguageCode);
  }
}

document.getElementById('popup-lang-select').addEventListener('change', () => {
  updateHiddenFields(
    document.getElementById('popup-country-select').value,
    document.getElementById('popup-lang-select').value
  );

  // 언어 선택 후 검색창 숨기기
  const searchInput = document.getElementById('dynamic-search-input');
  if (searchInput) {
    searchInput.remove();
  }
});

function updateHiddenFields(countryCode, languageCode) {
  document.getElementById('country_code').value = countryCode;
  document.getElementById('language_code').value = languageCode;
}


// 전체 국가 UI 렌더링 함수
function renderAllCountriesUI(countries) {
  const searchHistoryDiv = document.querySelector('.search-history');
  searchHistoryDiv.innerHTML = ''; // 기존 내용 초기화
  
  countries.sort((a, b) => a.name.localeCompare(b.name, 'ko'));

  countries.forEach(country => {
    country.availableLanguages.forEach(language => {
      const resultDiv = document.createElement('div');
      const countryParagraph = document.createElement('p');
      const languageParagraph = document.createElement('p');
      
      resultDiv.classList.add('linkbtn', 'result-link');
      resultDiv.setAttribute('data-country', country.isoCode);
      resultDiv.setAttribute('data-market', country.market?.handle || ''); // 데이터 속성에 마켓 핸들 추가
      resultDiv.setAttribute('data-language', convertIsoCode(language.isoCode) );

      countryParagraph.textContent = `${country.name} (${country.currency.isoCode} ${country.currency.symbol})`;
      languageParagraph.textContent = language.name;
      languageParagraph.classList.add('lang');
      
      resultDiv.appendChild(countryParagraph);
      resultDiv.appendChild(languageParagraph);
      searchHistoryDiv.appendChild(resultDiv);
    });
  });
}




// Cookie utility functions
function setCookie(name, value, days) {
  const domain = "lewkin.com"; // 고정 도메인 값 설정
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; domain=${domain}`;
}

function getCookie(name) {
  const cookieArr = document.cookie.split(";");
  for (let cookie of cookieArr) {
    cookie = cookie.trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return "";
}


// function getCountryNameByISO(isoCode) {
//   const matchedCountry = availableCountries.find(country => country.isoCode === isoCode);
//   return matchedCountry ? matchedCountry.name : 'Unknown Country';
// }

function getCountryNameByISO(isoCode) {

  const matchedCountry = availableCountries.find(country => country.isoCode === isoCode);
  if (!matchedCountry) {
    document.getElementById('popup-country-select').querySelector('option[value="US"]').selected = true;
    document.querySelector('.recmsgx').style.display = 'none';

  }
  return matchedCountry.name;
}

function shx(countries) {
  const selectElementx = document.getElementById('shx');

 if (!selectElementx) {
    console.warn('Element with ID "shx" does not exist.');
    return;
  }
  
  // 기존 옵션 제거
  selectElementx.innerHTML = '';

  // 국가 배열을 기반으로 옵션 추가
  countries.forEach(country => {
    const option = document.createElement('option');

    // 속성 설정
    option.value = country.isoCode; // value 속성에 isoCode 설정
    option.setAttribute('data-lang', JSON.stringify(country.availableLanguages)); // data-lang 속성에 언어 정보 설정
    option.setAttribute('data-handle', country.market?.handle || ''); // data-handle 속성에 마켓 핸들 설정
    option.setAttribute('data-iso', country.isoCode); // data-iso 속성에 isoCode 설정
    option.setAttribute('data-crc', country.currency?.isoCode || ''); // data-crc 속성에 커런시 코드 설정

    // 표시 텍스트 설정
    option.textContent = country.name;

    // <select>에 옵션 추가
    selectElementx.appendChild(option);
  });
}




// ipinfo.io API를 사용하여 IP 정보를 가져오는 함수
async function getRegionInfo() {
  if (window.location.pathname === "/") {
    
      try {
          const response = await fetch('https://mplvkxh5rk.execute-api.ap-northeast-2.amazonaws.com/ipinfo/');
          const data = await response.json();
          detectedCountryISO = data.country; // ISO 국가 코드 저장
  
          const infoElement = document.getElementById('infoipx');
          const countryName = getCountryNameByISO(data.country);
  
          infoElement.innerHTML = `
              <strong>${countryName}</strong>
          `;
        
          const countryList = document.querySelectorAll('#countryListRc li');
          countryList.forEach(li => {
              if (li.getAttribute('data-iso') === detectedCountryISO) {
                  li.classList.add('active'); // 일치하는 경우 active 클래스 추가
              }
          });
        
      } catch (error) {
          console.error('Error fetching IP information:', error);
      }
  
  
  };


};



function handleLocalizationSubmission(cookieName) {
  const cookieValue = getCookie(cookieName);

  if (!cookieValue) {
    console.error(`Cookie "${cookieName}" not found or not set.`);
    return;
  }

  try {
    // 쿠키 값을 JSON으로 파싱
    const parsedCookie = JSON.parse(cookieValue);

    // 쿠키 값에서 country_code와 language_code 추출
    const cookieCountryCode = parsedCookie.country_code?.toLowerCase();
    const cookieLanguageCode = parsedCookie.language_code?.toLowerCase();
    
    // console.log("쿠키값:", cookieLanguageCode, "-", cookieCountryCode);

    // 렌더링된 hidden input 값 가져오기
    const countryInput = document.getElementById("country_code");
    const languageInput = document.getElementById("language_code");

    if (!countryInput || !languageInput) {
      console.error("Required input elements not found.");
      return;
    }

    const renderedCountryCode = countryInput.value.toLowerCase();
    const renderedLanguageCode = languageInput.value.toLowerCase();

    // console.log("렌더링된 값:", renderedLanguageCode, "-", renderedCountryCode);

    // 쿠키 값과 렌더링된 값 비교
    if (cookieCountryCode !== renderedCountryCode || cookieLanguageCode !== renderedLanguageCode) {


      // 쿠키 값을 input 필드에 업데이트
      countryInput.value = cookieCountryCode.toUpperCase(); // ISO 국가 코드는 대문자로
      languageInput.value = cookieLanguageCode;

      // 폼 제출
      const localizationFormPopup = document.getElementById("localization_form");
      if (localizationFormPopup) {
        localizationFormPopup.submit();
      } 
    } else {
      console.log("Values match. No form submission required.");
    }
  } catch (error) {
    console.error("Error parsing cookie:", error);
  }
}




  